/**
 * Extracts a human-readable message from an unknown caught error.
 * Checks for Axios-style response.data.detail first, then message.
 */
export function getErrorMessage(err: unknown): string {
  if (err != null && typeof err === 'object') {
    const detail =
      'response' in err
        ? (err as { response?: { data?: { detail?: unknown } } }).response?.data?.detail
        : undefined;
    if (typeof detail === 'string') return detail;
    // FastAPI returns 422 detail as an array of validation error objects: [{loc, msg, type}]
    if (Array.isArray(detail) && detail.length > 0) {
      const msgs = detail
        .map((d: { msg?: string }) => d.msg)
        .filter((m): m is string => typeof m === 'string' && m.length > 0);
      if (msgs.length > 0) return msgs.join('; ');
    }

    const message =
      'message' in err
        ? (err as { message?: string }).message
        : undefined;
    if (typeof message === 'string') return message;
  }
  return 'An unexpected error occurred.';
}
